import React, {useEffect, useState} from 'react';
import { Button, Modal, Paper, Switch, Table, TableBody, TableCell, 
  TableContainer, TableHead, TableRow, Typography, Grid
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import LaunchIcon from '@material-ui/icons/Launch';
import { useDispatch, useSelector } from 'react-redux';
import useStyles from './style';
import { activateZone, deleteZone, fetchZones } from '../../../redux/actions/zoneActions';
import NewZone from './newZone';
import EditZone from './editZone';

const Zones = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [showNewForm, setShowNewForm] = useState(false);
  const [showEditForm, setShowEditForm] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [deleteName, setDeleteName] = useState(null);
  const [selectedZone, setSelectedZone] = useState(null);

  const [alert, setAlert] = useState({
    isOpen: false,
    type: '',
    message: ''
  })
  

  const zones = useSelector(state => state.zones.zones.data);
  useEffect(()=>{
    dispatch(fetchZones());
  },[zones]);
  let i = 1;

  const activate = (e) => {
    dispatch(activateZone(e.target.name, e.target.checked));
  }

  const onDeleteClick = (id, title) => {
    setOpenModal(true);
    setDeleteId(id);
    setDeleteName(title);
  }

  const handleCancel = () => {
    setDeleteId(null);
    setDeleteName(null);
    setOpenModal(false);
  }

  const handleEdit = (zone) => {
    setShowEditForm(true);
    setSelectedZone(zone);
  }

  const handleDetails = (zone) => {
    setShowDetails(true);
    setSelectedZone(zone);
  }

  const handleDelete = () => {
    dispatch(deleteZone(deleteId));
    setOpenModal(false);
    setAlert({
      isOpen: true,
      type: 'success',
      message: 'Zone deleted successfully !'
    })
  }

  useEffect(()=>{
    alert.isOpen && setTimeout(() => {
      setAlert({isOpen: false, type: '', message: ''})
    }, "3000")
  })

  const columns = ['N°', 'Title', 'Field', 'Owner', 'Area', 'Active', 'Actions'];

  return (
    <div>
      {alert.isOpen && (
        <Alert variant="filled" severity={alert.type} onClose={()=>{setAlert({isOpen: false})}} className={classes.alert}>
          {alert.message}
        </Alert>
      )}
      <div className={classes.between}>
       <Typography variant="h4" color="primary" style={{paddingLeft: 30}}>
          Zones
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={()=>setShowNewForm(true)}
          className={classes.newButton}
          startIcon={<AddIcon />}
        >
          New Zone
        </Button>
      </div>
      
      <Grid container spacing={3}>
        <Grid item xs={12} lg={(showNewForm || showEditForm || showDetails) ? (7) : (12)}>
          <TableContainer component={Paper} className={classes.paperPad}>
            <Table className={classes.table} aria-label="simple table">
              <TableHead>
                <TableRow>
                  {columns.map((column)=>(<TableCell key={column}>{column}</TableCell>))}
                </TableRow>
              </TableHead>
              <TableBody>
                {zones && zones.map((zone) => (
                  <TableRow key={zone._id}>
                    <TableCell>{i++}</TableCell>
                    <TableCell>{zone.title}</TableCell>
                    <TableCell>{zone.field.title}</TableCell>
                    <TableCell>{zone.field.user.firstname} {zone.field.user.lastname}</TableCell>
                    <TableCell>{zone.area} m²</TableCell>
                    <TableCell>
                      <Switch
                        checked={zone.isActive}
                        onClick={activate}
                        color="primary"
                        name={zone._id}
                        inputProps={{ 'aria-label': 'primary checkbox' }}
                      />
                    </TableCell>
                    <TableCell>
                      <div className={classes.actionIcons}>
                        {/* <LaunchIcon className={classes.actionIcon} onClick={()=> handleDetails(field)} /> */}
                        <EditIcon className={classes.actionIcon} onClick={()=>handleEdit(zone)} />
                        <DeleteIcon className={classes.actionIcon} onClick={()=>onDeleteClick(zone._id, zone.title)} />
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        {showNewForm && (
        <Grid item xs={12} lg={5}>
          <NewZone showIt={setShowNewForm} setAlert={setAlert}/>
        </Grid>
        )}
         
        {showEditForm && (
        <Grid item xs={12} lg={5}>
          <EditZone showIt={setShowEditForm} zone={selectedZone} setAlert={setAlert}/>
        </Grid>
        )}
        {/*
        {showDetails && (
        <Grid item xs={12} lg={5}>
          <UserDetails showIt={setShowDetails} selectedUser={selectedUser}/>
        </Grid>
        )} */}
      </Grid>
      <Modal
        open={openModal}
        onClose={handleCancel}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
      >
        <div className={classes.modalPaper}>
          <Typography variant="h5" color='primary' gutterBottom>
            Delete Zone
          </Typography>
          <Typography variant="body1" gutterBottom>
            Are you sure you want to delete <b>{deleteName}</b> ?
          </Typography>
          <br/>
          <div className={classes.flexRight}>
            <Button variant="contained" size='small' className={classes.modalBtn} color="primary" onClick={handleDelete}>
              Delete
            </Button>
            <Button variant="contained" size='small' className={classes.modalBtn} onClick={handleCancel}>
              Cancel
            </Button>
          </div>
        </div>
      </Modal>
      {/* <Maps fields={fields}/> */}
    </div>
  )
}
export default Zones;